<template>
  <div class="bulk-trade">
    <div class="banner">
      <img src="../../../assets/img/businessScope/bulkTrade/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("bulkTrade.banner.bannerTitle")}}</h1>
          <p>{{$t("bulkTrade.banner.bannerP")}}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="headline">
        <h1>{{$t("bulkTrade.headlineTitle")}}</h1>
        <p>{{$t("bulkTrade.headlineP")}}</p>
      </div>
      <el-row :gutter="30">
        <el-col :span="6" :xs="24">
          <div data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
             <!--左侧菜单组件-->
              <el-menu
                :default-active="activeMenu"
                class="el-menu-vertical-demo"
                @select="menuSelected"
                background-color="#fff"
                text-color="#333"
                active-text-color="#0054a7"
                :unique-opened="true">
                <NavMenu :navMenus="leftMenus"></NavMenu>
              </el-menu>
          </div>
        </el-col>
        <el-col :span="18" :xs="24" class="product-lists">
          
          <el-row :gutter="30">
              <el-col :span="8" :xs="12" v-for="(item,index) in tabLists" :key="index">

                <div class="pic-wrap" v-if="item.itemName=='石油焦' || item.itemName=='Petroleum Coke' || item.itemName=='Нефтяной Kокс'">
                  <router-link to="/gpc">
                    <div class="pic" :style="{height:imgH+'px'}" ref="pic">
                      <img src="../../../assets/img/businessScope/bulkTrade/hot.png"  class="tag"/>
                      <div class="tag-name">{{$t("bulkTrade.mainBusiness")}}</div>
                      <img :src="item.mainPicUrl" class="picurl"/>
                    </div>
                    <div class="des-row">
                        <p>{{item.itemName}}</p>
                        <p>{{item.introduction}}</p>
                    </div>
                  </router-link>
                </div>
 
                <div class="pic-wrap" v-else-if="item.itemName=='煅后焦' || item.itemName=='Calcined Coke' || item.itemName=='Прокаленный Kокс'">
                  <router-link to="/cpc">
                    <div class="pic" :style="{height:imgH+'px'}" ref="pic">
                      <img src="../../../assets/img/businessScope/bulkTrade/hot.png"  class="tag"/>
                      <div class="tag-name">{{$t("bulkTrade.mainBusiness")}}</div>
                      <img :src="item.mainPicUrl" class="picurl"/>
                    </div>
                    <div class="des-row">
                        <p>{{item.itemName}}</p>
                        <p>{{item.introduction}}</p>
                    </div>
                  </router-link>
                </div>

                <div class="pic-wrap" @click="toDetail(item.itemNo)" v-else>
                  <div class="pic" :style="{height:imgH+'px'}" ref="pic">
                      <img :src="item.mainPicUrl" class="picurl"/>
                  </div>
                  <div class="des-row">
                      <p>{{item.itemName}}</p>
                      <p>{{item.introduction}}</p>
                  </div>
                </div>
              </el-col>
          </el-row>

          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="pageReq.page"
            :limit.sync="pageReq.size"
            @pagination="getList"
          />
          
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getitemtypetree, getItemlist } from "@/api/product"
export default {
  name: "DulkTrade",
  computed:{
    ...mapGetters(['language'])
  },
  data() {
    return {
      imgH:"",
      tabLists:[],
      leftMenus:[],
      activeMenu:'',
      total:0,
      pageReq: {
        page: 1,
        size: 10,
      },
    };
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
    
    getitemtypetree(this.language).then(res=>{
      this.leftMenus = res.data;
      this.activeMenu = String( this.getActive( res.data[0] ) );
      
      this.getList();
    });

  },
  methods: {
    //递归active
    getActive( obj ){
      if( obj.children ){
        return this.getActive( obj.children[0] )
      } else{
        return obj.id
      }
    },
    // 获取列表
    getList(){
      const pageReq = {...this.pageReq};
      pageReq.page -= 1;

      getItemlist( this.language,{itemTypeId: this.activeMenu },pageReq ).then(res=>{
        const { content, totalElements } = res;
        this.tabLists = content;
        this.total = totalElements;
        this.$nextTick(()=>{
          this.imgH=this.$refs.pic[0].offsetWidth;
        })
      })
    },
    toDetail(itemNo){
      this.$router.push({path:`/besinessScope/bulkTrade/detail/${itemNo}`})
    },
    menuSelected(key, keyPath){
      this.activeMenu = key;
      this.getList();
    }
  }
};
</script>

<style scoped lang="scss">
.bulk-trade {
  .product-lists{
    .pic-wrap{
     // transition: all 0.4s #0052ac;
      margin-bottom:20px;
      &:hover{
        color:#0052ac;
        cursor: pointer;
        box-shadow: 0 0 3px ;
        // img{
        //   transform: scale(1.1);
        // }
      }
      .pic{
          background: #F4F4F4;
          border-radius: 22px;
          // display: flex;
          // justify-content: center;
          // align-items: center;
          overflow: hidden;
          position: relative;
          .tag{
            position: absolute;
            left:0;
            top:0;
          }
          .tag-name{
            position: absolute;
            left:5px;
            top:5px;
            color:#fff;
          }
          .picurl{
            // max-width: 80%;
            // max-height: 80%;
            object-fit: cover;
            height:100%;
            width:100%;
          }
      }
      .des-row{
          padding:15px;
          p{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
      }
    }
        
  }
  @media screen and (max-width:768px){
    .product-lists{
      margin-top:40px;
      .pic-wrap{

        .pic{
            border-radius: 10px;
        }
      }
          
    }
  }
}
</style>
